import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'outfitKeyValue',
    standalone: false
})
export class OutfitKeyValuePipe implements PipeTransform {
  stringFromObject(hashObj: { [key: string]: any }) {
    let separation = '';
    let out = '';
    let keys = Object.keys(hashObj);
    for (const key of keys) {
      let value = hashObj[key];
      if (isNaN(value)) {
        out = out + separation + key + ':{' + this.stringFromObject(value) + '}';
      }
      else {
        out = out + separation + key + ':' + value;
      }
      separation = ', ';
    }
    return out;
  };

  transform(input: string | undefined, ...args: unknown[]): string {
    let parsed = JSON.parse(input || '{}');
    let out = this.stringFromObject(parsed);
    return out;
  };
};
